import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { ModalController, AlertController, IonInput } from "@ionic/angular/lazy";
import { CartService } from "../../services/cart.service";
import Decimal from "decimal.js";

@Component({
    selector: "app-cart-discount",
    templateUrl: "./cart-discount.page.html",
    styleUrls: ["./cart-discount.page.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CartDiscountPage implements OnInit {

	discount_rate = 0;

	constructor(public modalController: ModalController, public alertController: AlertController, private cartService: CartService) {}

	ngOnInit() {
		this.cartService.get().then((cart: any) => {
			if (cart.items.length === 0) return;
			var discount_rate = cart.items[0].discount_rate;
			for (var item of cart.items) {
				if (item.discount_rate != discount_rate) return;
			}
			this.discount_rate = discount_rate;
		});
	}

	enterPressed(event) {
		// NOTE: the input is debounced, so take the typed value directly in case the model hasn't caught up yet
		this.discount_rate = event.target.value;
		this.update();
	}

	async update() {
		if (isNaN(this.discount_rate) || (this.discount_rate as any) === "" || this.discount_rate < 0 || this.discount_rate > 100) return;
		this.discount_rate = Number(new Decimal(this.discount_rate).toDecimalPlaces(4));
        // TODO: move to cartService
		var cart: any = await this.cartService.get();
        if(!cart['locked']) {
            for (var i = 0; i < cart.items.length; i++) {
                cart.items[i].discount_type = 'percentage';
                cart.items[i].discount_amount = this.discount_rate;
            }
            this.cartService.set(cart);
        }
		this.close();
	}

	close() {
		this.modalController.dismiss();
	}

}